export default (slideElementFields) => ({
  headline: slideElementFields.headline.value,
  subheadline: slideElementFields.subheadline?.value,
  url: slideElementFields.link?.value?.href,
  isButton: Boolean(slideElementFields.isButton?.value),
  buttonText: slideElementFields.buttonText?.value,
});
